import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('');
export default function P() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2.river2.details');
    const { locale } = useRouter();
    const [winW, setWinW] = useState(375);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window?.innerWidth);
        }
    }, []);

    const lists = [
        {
            img: '/media/river2/h5/P16_2.png',
            title: t('sec16_item_1_title'),
            descrition: t('sec16_item_1_desc'),
        },
        {
            img: '/media/river2/h5/P16_3.png',
            title: t('sec16_item_2_title'),
            descrition: t('sec16_item_2_desc'),
        },
        {
            img: '/media/river2/h5/P16_4.png',
            title: t('sec16_item_3_title'),
            descrition: t('sec16_item_3_desc'),
        },
    ];

    return (
        <div className={`river2_details_P ${css.P_16}`}>
            <div className="bgImg">
                <div className="innerBox">
                    <p className="title">{t('sec16_title')}</p>
                    <div className="img-box">
                        <EFPic
                            name={
                                locale === 'za'
                                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711699334286/r2p_p1_1_768_za.jpg'
                                    : ['/media/river2/h5/P16_1.png', '/media/river2/h5/P16_1.png']
                            }
                            className="fullImgs"
                            alt={t('sec16_title')}
                            aria-label={t('sec16_title')}
                        />
                    </div>
                    <p className="desc">
                        {t.rich('sec16_desc', {
                            p1: (h: string) => <span className="white">{h}</span>,
                        })}
                    </p>
                    <div className="swiperBox">
                        <Swiper
                            className={`river2_deatails_D_swiper`}
                            slidesPerView={'auto'}
                            spaceBetween={(winW / 375) * 15}
                            slidesOffsetBefore={(winW / 375) * 24}
                            initialSlide={0}
                            preloadImages={false}
                            lazy
                            grabCursor
                        >
                            {lists.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <div className="content">
                                        <div className="top-img">
                                            <EFPic name={[item.img, item.img]} className="fullImgs" alt={item.title} aria-label={item.title} />
                                        </div>
                                        <div className="img-desc">
                                            <div className="img-title">{item.title}</div>
                                            <div className="descrition">{item.descrition}</div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}
